import SearchEngine2D from "@/Components/Apartments/SearchEngine2D";
import SearchEngine3D from "@/Components/Apartments/SearchEngine3D";
import Column from "@/Components/Grid/Column";
import Container from "@/Components/Grid/Container";
import Row from "@/Components/Grid/Row";
import { HighlightedApartment } from "@/Components/Homepage/HighlightedApartment";
import ContactForm from "@/Components/Universal/ContactForm";
import TopHero from "@/Components/Universal/TopHero";
import FrontLayout from "@/Layouts/FrontLayout";
import { PaginationLink } from "@/types/components/pagination/pagination";
import { ApartmentModel } from "@/types/models/apartment";
import { SearchEngineData } from "@/types/searchEngineData";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Head, Link, router } from "@inertiajs/react";
import { useEffect, useState } from "react";

const Index = ({
    searchEngineParams,
    apartments,
}: {
    searchEngineParams: SearchEngineData;
    apartments: {
        data: ApartmentModel[];
        links: PaginationLink[];
        total: number;
    };
}) => {
    const [defaulSearchEngine, setDefaulSearchEngine] = useState<"2d" | "3d">(
        "2d",
    );
    const { variation } = route().params;

    useEffect(() => {
        const { variation } = route().params;

        if (variation !== null && (variation == "2d" || variation == "3d")) {
            // @ts-ignore
            setDefaulSearchEngine(variation);
        }
    }, []);

    const handleSearchEngineChange = (type: "2d" | "3d") => {
        setDefaulSearchEngine(type);

        router.visit(
            route("frontend.apartments", {
                _query: {
                    variation: type,
                },
            }),
            {
                preserveScroll: true,
                preserveState: true,
            },
        );
    };

    return (
        <>
            <Head title="Osiedle Kusocińskiego">
                <meta name="description" content="Osiedle Kusocińskiego" />
            </Head>
            <FrontLayout>
                <aside className="mt-[168px] mb-14 maxMd:my-14"></aside>
                {defaulSearchEngine == "3d" && (
                    <SearchEngine3D additionalButtons />
                )}
                {defaulSearchEngine == "2d" && (
                    <SearchEngine2D
                        searchEngineParams={searchEngineParams}
                        apartments={apartments}
                    />
                )}
                <HighlightedApartment />
                <ContactForm smallerMargin />
            </FrontLayout>
        </>
    );
};

export default Index;
